import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Copy2Svg } from '@cashier/cashier-assets';
import { useCopyToClipboard } from '@cashier/cashier-shared';

import styles from './styles.module.scss';

interface CryptoCurrencyProps {
  label: string;
  text: string;
  warningMessage: string;
}

export const AlternativeCopyableText = ({
  label,
  text,
  warningMessage,
}: CryptoCurrencyProps): ReactElement => {
  const { t } = useTranslation();
  const { copyToClipboard, copied } = useCopyToClipboard();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.left}>{label}</div>
        <div className={styles.right}>
          {text}
          <div
            className={styles.icon}
            onClick={() => copyToClipboard(text)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                copyToClipboard(text);
              }
            }}
          >
            <Copy2Svg />
            {copied && <p className={styles.message}>{t('copied.message')}</p>}
          </div>
        </div>
      </div>
      <div className={styles.warning}>{warningMessage}</div>
    </>
  );
};
